import React from 'react';
import { Box, Typography } from '@mui/material';

const Reports = () => {
    return (
        <Box>
            <Typography variant="h4">Reportes</Typography>
            <Typography>Funcionalidad de reportes detallados en construcción.</Typography>
        </Box>
    );
};

export default Reports;
